const haemoptysis=[

    { 
    label:"Relationship to sputum:",
    controlType:"checkbox group",
    options:["Mixed with sputum ", "Frank blood"],
    },

    {
    label:"Character:",
    controlType:"checkbox group",
    options:["Fresh blood", "Dark blood"],
    },

    { 
    label:"Blood clots:",
    controlType:"radio button",
    options:["Yes", "No"]
    }, 
    
    {
    label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Evey week or two", "Occasionally"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }

        ]
        
    
    
    export default haemoptysis